<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="DurationEnum.LessOneMonth" i18n>Moins d’un mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.OneAndThreeMonths" i18n>Entre 1 et 3 mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.FourAndSixMonths" i18n>Entre 4 et 6 mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.SevenAndTwelveMonths" i18n>Entre 7 et 12 mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.ThirteenAndTwentyFourMonths" i18n>Entre 13 et 24 mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.TwentyFiveAndThirtySixMonths" i18n>Entre 25 et 36 mois</ng-container>
  <ng-container *ngSwitchCase="DurationEnum.Undetermined" i18n>Indéterminée</ng-container>

  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
